import DataObject from "@mui/icons-material/DataObject";
import Laptop from "@mui/icons-material/Laptop";
import Storage from "@mui/icons-material/Storage";
import Tag from "@mui/icons-material/Tag";
import Tune from "@mui/icons-material/Tune";
import { Chip, type ChipProps,styled } from "@mui/material";
import type { FC, ReactElement } from "react";

import {
	CATEGORY_BOOLEAN_VALUES,
	CATEGORY_DATABASE_TABLES,
	CATEGORY_SCREEN_FIELDS,
	CATEGORY_VARIABLES,
} from "../constants";

const CATEGORY_CHIP_ICONS: Record<string, ReactElement> = {
	[CATEGORY_BOOLEAN_VALUES]: <Tune fontSize="small" />,
	[CATEGORY_VARIABLES]: <DataObject fontSize="small" />,
	[CATEGORY_SCREEN_FIELDS]: <Laptop fontSize="small" />,
	[CATEGORY_DATABASE_TABLES]: <Storage fontSize="small" />,
};

const StyledChip = styled(Chip)({
	backgroundColor: "#0195D51A",
	border: "#0195D5",
	borderRadius: "5px",
	color: "#111111",
	"& .MuiChip-icon": {
		color: "#0195D5",
	},
	"& .MuiChip-deleteIcon": {
		color: "#0195D5",
	},
});

export interface MatchedValueChipProps extends Omit<ChipProps, "icon"> {
	category: string;
}

export const MatchedValueChip: FC<MatchedValueChipProps> = ({
	category,
	...chipProps
}) => (
	<StyledChip
		icon={CATEGORY_CHIP_ICONS[category] ?? <Tag fontSize="small" />}
		{...chipProps}
	/>
);
